export default __webpack_public_path__ + "static/media/info.cb92c1db.svg";